import { features } from './features'; 

features.applicationType = 'agrogest';

features.clienteName = 'Empresa';
features.clientesName = 'Empresas';

features.showSectores = false;
features.showParcelas = false;
features.showMapas = false;
features.showAnalisis = true;
features.showVentas = false;
features.showAplicadoresPartes = true;
features.showTrabajadoresCargos = true;
features.hasClients = true;
features.showStock = true;
features.showSectorPlantas = false;
features.showProductosNumReg = false;
features.fertilizantesNombreRequired = true;
features.fertilizantesUdsMedidaRequired = true;
features.showVisitas = false;
features.showHistoricoFT = false;
features.showExepcionales = false;
features.showOtrasDenominaciones = false;
features.showRecetaVGiner = false;
features.showRecetaGlobalGAP = true;
features.showRecetaFirmas = true;
features.showClientesFirma = true;
features.showUsuariosFirma = true;
features.showEnviarCorreo = true;
features.showEnviarWhatsapp = true;
features.showControlRiego = false;

features.showTareasParcela = false;
features.showFertilizantesParcelas = false;
features.showTareasSector = false;
features.showTareasFitoLitrosAplicados = true;
features.showFincasProductos = true;
features.showTareasFitoSectorMultiple = true;
features.showTareasFitoHoras = true;
features.showFincasRazonSocial = true;
features.showPerfilFincas = false;
features.showTareasFertilizantes = true;
features.showTareasOtros = true;
features.showFertilizantesCa = true;

features.showFertisComposicionCol = false;
features.showFertisOtrosCompuestosCol = false;
features.showTratamientosRecetaSwitch = false;
features.showFincasCodigo = true;
features.showParcelasCodigoTrazabilidad = true;
features.showTareasFitoIT = true;
features.showDescripcion = false;
features.showStockMarcaComercial = true;
features.showStockTipoDeDato = false;
features.showStockage = false;
features.showCostes = true;
features.showAplicadoresFichajes = true;

features.showMapaLabels = true;
features.showClimatologia = false;

features.showTrabajadoresClienteAsignado = true;
features.showTrabajadoresUserYPass = true;
features.activateREA = false;
features.showFormatHourMinute = false;
features.horaFechaFinActualPorDefecto = true;

export const environment = {
    production: true,
    v: '1',
    serverUrl: 'https://tomega.agrogest.com/',
    logoUrl: 'assets/logo_tomega.png',
    logoLoginUrl: 'assets/logo_tomega.png',
    appName: 'tomega',
    features: features
};
